export default __webpack_public_path__ + "static/media/bronzeCup.eabc721c.svg";